<div class="auctions-map"><trading-map></trading-map></div>